import { render } from "./MiscellaneousAddenda.vue?vue&type=template&id=1b40d272&scoped=true"
import script from "./MiscellaneousAddenda.vue?vue&type=script&lang=js"
export * from "./MiscellaneousAddenda.vue?vue&type=script&lang=js"

import "./MiscellaneousAddenda.vue?vue&type=style&index=0&id=1b40d272&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b40d272"]])

export default __exports__